import JSZip from 'jszip';
import { PAGES } from './brochurePages';

const loadImage = (src) =>
  new Promise((res, rej) => {
    const im = new Image();
    im.onload = () => res(im);
    im.onerror = rej;
    im.src = src;
  });

const toJpegBlob = (img) => {
  const canvas = document.createElement('canvas');
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  canvas.getContext('2d').drawImage(img, 0, 0);
  return new Promise((res) => canvas.toBlob(res, 'image/jpeg', 0.92));
};

const pageXhtml = (n, label) => `<?xml version="1.0" encoding="utf-8"?>
<!DOCTYPE html>
<html xmlns="http://www.w3.org/1999/xhtml">
<head><meta charset="utf-8"/><title>${label}</title>
<style>html,body{margin:0;padding:0;height:100%;}img{display:block;width:100%;height:100%;}</style></head>
<body><img src="images/page-${n}.jpg" alt="${label}"/></body>
</html>`;

const buildOpf = (modified) => {
  const manifestPages = PAGES.map(
    (_, i) =>
      `    <item id="page${i + 1}" href="page-${i + 1}.xhtml" media-type="application/xhtml+xml"/>\n    <item id="img${i + 1}" href="images/page-${i + 1}.jpg" media-type="image/jpeg"/>`
  ).join('\n');
  const spine = PAGES.map((_, i) => `    <itemref idref="page${i + 1}"/>`).join('\n');
  return `<?xml version="1.0" encoding="utf-8"?>
<package xmlns="http://www.idpf.org/2007/opf" version="3.0" unique-identifier="bookid">
  <metadata xmlns:dc="http://purl.org/dc/elements/1.1/">
    <dc:identifier id="bookid">urn:uuid:${crypto.randomUUID()}</dc:identifier>
    <dc:title>Trinity Masterclass — Anno Accademico 2026-2027</dc:title>
    <dc:creator>Amici per la Musica APS</dc:creator>
    <dc:language>it</dc:language>
    <dc:description>Brochure digitale delle Masterclass 2026-2027 — Trinity Musical School, Rovigo e Polesella</dc:description>
    <meta property="dcterms:modified">${modified}</meta>
  </metadata>
  <manifest>
    <item id="nav" href="nav.xhtml" media-type="application/xhtml+xml" properties="nav"/>
${manifestPages}
  </manifest>
  <spine>
${spine}
  </spine>
</package>`;
};

const buildNav = () => {
  const items = PAGES.map(
    (p, i) => `        <li><a href="page-${i + 1}.xhtml">${p.label}</a></li>`
  ).join('\n');
  return `<?xml version="1.0" encoding="utf-8"?>
<!DOCTYPE html>
<html xmlns="http://www.w3.org/1999/xhtml" xmlns:epub="http://www.idpf.org/2007/ops" lang="it">
<head><meta charset="utf-8"/><title>Indice</title></head>
<body>
  <nav epub:type="toc">
    <h1>Trinity Masterclass 2026-2027</h1>
    <ol>
${items}
    </ol>
  </nav>
</body>
</html>`;
};

const CONTAINER_XML = `<?xml version="1.0" encoding="utf-8"?>
<container version="1.0" xmlns="urn:oasis:names:tc:opendocument:xmlns:container">
  <rootfiles>
    <rootfile full-path="OEBPS/content.opf" media-type="application/oebps-package-document"/>
  </rootfiles>
</container>`;

export const buildEpub = async () => {
  const zip = new JSZip();
  zip.file('mimetype', 'application/epub+zip', { compression: 'STORE' });
  zip.file('META-INF/container.xml', CONTAINER_XML);
  const oebps = zip.folder('OEBPS');
  const images = oebps.folder('images');
  for (let i = 0; i < PAGES.length; i++) {
    const img = await loadImage(PAGES[i].src);
    images.file(`page-${i + 1}.jpg`, await toJpegBlob(img));
    oebps.file(`page-${i + 1}.xhtml`, pageXhtml(i + 1, PAGES[i].label));
  }
  oebps.file('nav.xhtml', buildNav());
  oebps.file('content.opf', buildOpf(new Date().toISOString().replace(/\.\d+Z$/, 'Z')));
  return zip.generateAsync({
    type: 'blob',
    mimeType: 'application/epub+zip',
    compression: 'DEFLATE',
  });
};
